import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  wheelChooseItem: {
    background: 'transparent',
    maxWidth: '100%',
    overflow: 'hidden',
    border: 'none',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
    fontFamily: 'inherit',
    userSelect: 'none',
    transform: 'scale(0.9, 0.9)',
    fontWeight: 'regular !important',
    color: theme.colors.gray.normal,
    transition: `transform ${theme.speed.fast}ms`,
    '&[data-wheel-choose-selected]': {
      color: theme.colors.background.text,
      fontWeight: 'bold',
      transform: 'scale(1, 1)',
    },
  },
}));

export default useStyle;
